<template>
  <div class="list">
    <navbar :docsName="docsName" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <div class="container-fluid">
            <head-menu
              :col="12"
              :hide-date="true"
              class="d-xl-flex"
              headline="Datenschutz-Cockpit (nDSG)"
            />

            <!-- Toolbar -->
            <div class="row mb-2">
              <div class="block br-t-l-0 w-100-p br-t-l-xl-0">
              <div class="row d-flex justify-content-between align-items-center ml-1 mr-1">
                <div class="ml-2 d-flex">
                  <!-- Vorschläge-Tab actions -->
                  <template v-if="aktiverTab === 0">
                    <button
                      class="btn btn-success mr-2"
                      :disabled="ausgewaehlteVorschlaege.length === 0"
                      @click="aktion('BESTAETIGEN')"
                    >
                      <font-awesome-icon icon="fa-regular fa-check" class="mr-1" />
                      Bestätigen
                    </button>
                    <button
                      class="btn btn-warning mr-2"
                      :disabled="ausgewaehlteVorschlaege.length !== 1"
                      @click="oeffneZurueckstellenDialog"
                    >
                      <font-awesome-icon icon="fa-regular fa-clock" class="mr-1" />
                      Zurückstellen
                    </button>
                    <button
                      class="btn btn-danger mr-2"
                      :disabled="ausgewaehlteVorschlaege.length === 0"
                      @click="aktion('ABLEHNEN')"
                    >
                      <font-awesome-icon icon="fa-regular fa-xmark" class="mr-1" />
                      Ablehnen
                    </button>
                    <span v-if="ausgewaehlteVorschlaege.length > 0" class="text-muted align-self-center ml-2">
                      {{ ausgewaehlteVorschlaege.length }} ausgewählt
                    </span>
                  </template>
                  <!-- Einstellungen-Tab actions -->
                  <button
                    v-if="aktiverTab === 2"
                    class="btn btn-success mr-2"
                    @click="einstellungenSpeichern"
                  >
                    Einstellungen speichern
                  </button>
                </div>
                <div class="mr-2">
                  <button class="btn btn-primary" @click="ladeVorschlaege" title="Aktualisieren">
                    <font-awesome-icon icon="fa-regular fa-rotate" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Tabs -->
          <div class="row">
            <div class="col-xl-12 p-0">
              <ul class="nav nav-tabs mt-3 fs-28">
                <li class="nav-item">
                  <a class="primary-headline-text nav-link" :class="{ active: aktiverTab === 0 }" href="#" @click.prevent="aktiverTab = 0">
                    Löschvorschläge
                    <span v-if="vorschlaege.length > 0" class="badge badge-warning ml-1">{{ vorschlaege.length }}</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="primary-headline-text nav-link" :class="{ active: aktiverTab === 1 }" href="#" @click.prevent="aktiverTab = 1; ladeProtokoll()">
                    Protokoll
                  </a>
                </li>
                <li class="nav-item">
                  <a class="primary-headline-text nav-link" :class="{ active: aktiverTab === 2 }" href="#" @click.prevent="aktiverTab = 2; ladeEinstellungen()">
                    Einstellungen
                  </a>
                </li>
                <li class="nav-item">
                  <a class="primary-headline-text nav-link" :class="{ active: aktiverTab === 3 }" href="#" @click.prevent="aktiverTab = 3; lookupErgebnis = null">
                    Auskunft
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Tab content -->
          <div class="row">
            <div class="col-xl-12 p-0">
              <div class="tab-container p-3">

                <!-- Tab: Vorschläge -->
                <div v-if="aktiverTab === 0" class="belegliste w-100-p">
                  <b-table
                    ref="vorschlaegeTable"
                    small
                    tbody-tr-class="item"
                    :items="vorschlaege"
                    :fields="vorschlaegeFelder"
                    selectable
                    select-mode="multi"
                    sort-icon-left
                    :busy="ladeVorschlaegeAktiv"
                    @row-selected="onVorschlagSelected"
                  >
                    <template #table-busy>
                      <div class="text-center my-3">
                        <b-spinner small /> Lade Vorschläge…
                      </div>
                    </template>
                    <template #head(selected)>
                      <b-form-checkbox @change="alleAuswaehlen" />
                    </template>
                    <template #cell(selected)="{ rowSelected }">
                      <b-form-checkbox :checked="rowSelected" @change="(v) => v ? $refs.vorschlaegeTable.selectRow($parent.index) : $refs.vorschlaegeTable.unselectRow($parent.index)" />
                    </template>
                    <template #cell(personName)="{ item }">
                      <span :class="{ 'text-muted font-italic': istAnonymisiert(item) }">
                        {{ item.personName }}
                        <small v-if="istAnonymisiert(item)" class="text-warning ml-1">[Anonymisiert]</small>
                      </span>
                    </template>
                    <template #cell(actions)="{ item }">
                      <button class="btn btn-xs btn-success mr-1" @click.stop="aktionEinzeln(item, 'BESTAETIGEN')" title="Bestätigen">
                        <font-awesome-icon icon="fa-regular fa-check" />
                      </button>
                      <button class="btn btn-xs btn-warning mr-1" @click.stop="aktionEinzeln(item, 'ZURUECKSTELLEN')" title="Zurückstellen">
                        <font-awesome-icon icon="fa-regular fa-clock" />
                      </button>
                      <button class="btn btn-xs btn-danger" @click.stop="aktionEinzeln(item, 'ABLEHNEN')" title="Ablehnen">
                        <font-awesome-icon icon="fa-regular fa-xmark" />
                      </button>
                      <div v-if="zurueckstellenTarget === item.id" class="mt-1 d-flex align-items-center">
                        <b-form-datepicker
                          v-model="zurueckstelltBis"
                          locale="de-CH"
                          :min="morgen"
                          size="sm"
                          class="mr-1"
                          style="width:170px"
                          :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }"
                          reset-button
                          hide-header
                        />
                        <button class="btn btn-xs btn-warning mr-1" :disabled="!zurueckstelltBis" @click.stop="zurueckstellenBestaetigen">
                          <font-awesome-icon icon="fa-regular fa-check" />
                        </button>
                        <button class="btn btn-xs btn-secondary" @click.stop="schliesseZurueckstellenInline(item)">
                          <font-awesome-icon icon="fa-regular fa-xmark" />
                        </button>
                      </div>
                    </template>
                  </b-table>
                  <p v-if="!ladeVorschlaegeAktiv && vorschlaege.length === 0" class="text-center text-muted mt-3">
                    Keine offenen Löschvorschläge vorhanden.
                  </p>
                </div>

                <!-- Tab: Protokoll -->
                <div v-if="aktiverTab === 1" class="belegliste w-100-p">
                  <b-table
                    small
                    tbody-tr-class="item"
                    :items="protokoll"
                    :fields="protokollFelder"
                    sort-icon-left
                    :busy="ladeProtokollAktiv"
                  >
                    <template #table-busy>
                      <div class="text-center my-3">
                        <b-spinner small /> Lade Protokoll…
                      </div>
                    </template>
                    <template #cell(aktion)="{ item }">
                      <span :class="aktionBadgeClass(item.aktion)">{{ aktionLabel(item.aktion) }}</span>
                    </template>
                  </b-table>
                </div>

                <!-- Tab: Einstellungen -->
                <div v-if="aktiverTab === 2">
                  <div class="col-xl-6 mt-3">
                    <div class="form-group">
                      <select v-model="einstellungen['datenschutz.loeschUmfang']" class="form-control">
                        <option value="NUR_PERSONDATEN">Nur Personendaten (PII-Felder)</option>
                        <option value="MIT_ASSOZIIERTEN_DATEN">Mit assoziierten Daten — Standard</option>
                        <option value="VOLLSTAENDIG_CASCADE">Vollständig (inkl. Kursanmeldungen)</option>
                      </select>
                      <label>Löschumfang</label>
                      <small class="form-text text-muted">Steuert, welche Daten bei der Anonymisierung gelöscht werden.</small>
                    </div>
                    <div class="form-group mt-3">
                      <select v-model="einstellungen['datenschutz.modus']" class="form-control">
                        <option value="MANUELL">Manuell — Admin bestätigt jeden Vorschlag</option>
                        <option value="AUTO">Automatisch — Scan-Job führt direkt aus</option>
                      </select>
                      <label>Ausführungsmodus</label>
                      <small class="form-text text-muted">Im Modus MANUELL werden Vorschläge zur Bestätigung vorgelegt.</small>
                    </div>
                    <hr class="mt-4" />
                    <div class="form-group mt-3">
                      <label>Institutions-Schlüssel</label>

                      <!-- Schlüssel bereits konfiguriert: nur Status, keine Änderung möglich (write-once) -->
                      <template v-if="schluesselKonfiguriert">
                        <div class="mt-1">
                          <span class="badge badge-success py-2 px-3">
                            <font-awesome-icon icon="fa-solid fa-lock" class="mr-1" />
                            Schlüssel konfiguriert
                          </span>
                        </div>
                        <small class="form-text text-muted">
                          Der Schlüssel ist gesetzt und kann nicht mehr geändert werden.
                          Er ist dem Datenschutz-Verantwortlichen auszuhändigen.
                        </small>
                      </template>

                      <!-- Schlüssel noch nicht konfiguriert: einmalig setzen -->
                      <template v-else>
                        <div class="input-group">
                          <input
                            v-model="einstellungen['datenschutz.institutionKey']"
                            :type="schluesselSichtbar ? 'text' : 'password'"
                            class="form-control"
                            autocomplete="off"
                            placeholder=" "
                            readonly
                          />
                          <div class="input-group-append">
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              :disabled="!schluesselNeuGeneriert"
                              @click="schluesselSichtbar = !schluesselSichtbar"
                            >
                              <font-awesome-icon :icon="schluesselSichtbar ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'" />
                            </button>
                            <button
                              class="btn btn-outline-secondary"
                              type="button"
                              @click="generiereSchluessel"
                              title="Schlüssel generieren"
                            >
                              <font-awesome-icon icon="fa-solid fa-shuffle" />
                            </button>
                          </div>
                        </div>
                        <small v-if="schluesselNeuGeneriert" class="form-text text-warning">
                          <font-awesome-icon icon="fa-solid fa-triangle-exclamation" class="mr-1" />
                          Diesen Schlüssel jetzt kopieren und sicher aufbewahren (z.B. Passwort-Manager) —
                          er wird nach dem Speichern nicht mehr angezeigt.
                        </small>
                        <small v-else class="form-text text-muted">
                          Schlüssel generieren und speichern. Er kann danach nicht mehr geändert werden.
                        </small>
                      </template>
                    </div>

                    <hr class="mt-4" />
                    <div class="mt-3">
                      <h6>Manuelle Ausführung</h6>
                      <p class="text-muted small mb-3">
                        Jobs werden automatisch durch den Scheduler ausgeführt.
                        Diese Schaltflächen dienen zu Test- und Wartungszwecken.
                      </p>
                      <div class="d-flex flex-wrap">
                        <div class="mr-4 mb-3">
                          <button
                            class="btn btn-outline-secondary"
                            :disabled="scanAktiv || bereinigungAktiv"
                            @click="triggereJob('SCAN')"
                          >
                            <b-spinner v-if="scanAktiv" small class="mr-1" />
                            <font-awesome-icon v-else icon="fa-regular fa-rotate" class="mr-1" />
                            Scan ausführen
                          </button>
                          <div class="small text-muted mt-1">Scannt alle Personen, erstellt Löschvorschläge.</div>
                        </div>
                        <div class="mb-3">
                          <button
                            class="btn btn-outline-secondary"
                            :disabled="scanAktiv || bereinigungAktiv"
                            @click="triggereJob('BEREINIGUNG')"
                          >
                            <b-spinner v-if="bereinigungAktiv" small class="mr-1" />
                            <font-awesome-icon v-else icon="fa-regular fa-rotate" class="mr-1" />
                            Bereinigung ausführen
                          </button>
                          <div class="small text-muted mt-1">Befüllt fehlende datenschutz_uuid, löscht abgelaufene Tokens.</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Tab: Auskunft -->
                <div v-if="aktiverTab === 3">
                  <div class="col-xl-6 mt-3">
                    <p class="text-muted">
                      Geben Sie den Institutions-Schlüssel und die AHV-Nummer der betroffenen Person ein,
                      um die unter dieser Person gespeicherten Retention-Daten abzurufen.
                    </p>
                    <div class="form-group">
                      <input v-model="lookup.key" type="password" class="form-control" autocomplete="off" placeholder=" " />
                      <label>Institutions-Schlüssel</label>
                    </div>
                    <div class="form-group">
                      <input v-model="lookup.ahvNummer" type="text" class="form-control" placeholder=" " />
                      <label>AHV-Nummer</label>
                    </div>
                    <div v-if="lookupFehler" class="alert alert-danger">{{ lookupFehler }}</div>
                    <button class="btn btn-primary" :disabled="!lookup.key || !lookup.ahvNummer || lookupAktiv" @click="ausfuehrenLookup">
                      <b-spinner v-if="lookupAktiv" small class="mr-1" />
                      Daten abrufen
                    </button>

                    <template v-if="lookupErgebnis">
                      <hr class="mt-4" />
                      <small class="text-muted">UUID: <code>{{ lookupErgebnis.uuid }}</code></small>

                      <h6 class="mt-3">Kursanmeldungen ({{ lookupErgebnis.anmeldungen.length }})</h6>
                      <p v-if="lookupErgebnis.anmeldungen.length === 0" class="text-muted">Keine.</p>
                      <b-table
                        v-else
                        small
                        :items="lookupErgebnis.anmeldungen"
                        :fields="[{ key: 'veranstaltung', label: 'Veranstaltung' }, { key: 'bestandenAm', label: 'Bestanden am' }, { key: 'zertifizierung', label: 'Zertifizierung' }]"
                      />

                      <h6 class="mt-3">Dokumente ({{ lookupErgebnis.dokumente.length }})</h6>
                      <p v-if="lookupErgebnis.dokumente.length === 0" class="text-muted">Keine.</p>
                      <b-table
                        v-else
                        small
                        :items="lookupErgebnis.dokumente"
                        :fields="[
                          { key: 'bezeichnung', label: 'Bezeichnung' },
                          { key: 'datum', label: 'Datum', formatter: toSwissDatum },
                          { key: 'typ', label: 'Typ' },
                          { key: 'aktion', label: '' }
                        ]"
                      >
                        <template #cell(aktion)="{ item }">
                          <button
                            v-if="item.id"
                            class="btn btn-xs btn-outline-secondary"
                            title="Dokument öffnen"
                            @click="oeffneDokument(item)"
                          >
                            <font-awesome-icon icon="fa-regular fa-file-arrow-down" />
                          </button>
                        </template>
                      </b-table>
                    </template>
                  </div>
                </div>

              </div>
            </div>
          </div>

          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import AppApi from "@/api/AppApi";
import FileDownload from "js-file-download";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import page from "@/mixins/Page";
import HeadMenu from "@/components/HeadMenu";
import Navbar from "@/components/Navbar";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faRotate, faCheck, faClock, faXmark, faEye, faEyeSlash, faFileArrowDown } from "@fortawesome/pro-regular-svg-icons";
import { faLock, faShuffle, faTriangleExclamation } from "@fortawesome/pro-solid-svg-icons";
library.add(faRotate, faCheck, faClock, faXmark, faEye, faEyeSlash, faFileArrowDown, faLock, faShuffle, faTriangleExclamation);

const DATENSCHUTZ_VORSCHLAEGE_PATH   = "datenschutz/vorschlaege";
const DATENSCHUTZ_PROTOKOLL_PATH     = "datenschutz/protokoll";
const DATENSCHUTZ_EINSTELLUNGEN_PATH = "datenschutz/einstellungen";
const DATENSCHUTZ_LOOKUP_PATH        = "datenschutz/lookup";
const DATENSCHUTZ_JOBS_PATH          = "datenschutz/jobs";

function toSwissDatum(v) {
  if (!v) return "";
  const s = v.substring(0, 10); // "YYYY-MM-DD"
  return `${s.substring(8)}.${s.substring(5, 7)}.${s.substring(0, 4)}`;
}

function toSwissDatumZeit(v) {
  if (!v) return "";
  const dt = v.substring(0, 16); // "YYYY-MM-DD HH:mm" or "YYYY-MM-DDTHH:mm"
  const sep = dt.includes("T") ? "T" : " ";
  const [d, t = ""] = dt.split(sep);
  return `${d.substring(8)}.${d.substring(5, 7)}.${d.substring(0, 4)}${t ? " " + t : ""}`;
}

export default {
  name: "DatenschutzCockpit",
  components: {
    Navbar,
    HeadMenu,
  },
  mixins: [page],
  data() {
    return {
      docsName: "datenschutz",
      aktiverTab: 0,

      vorschlaege: [],
      ausgewaehlteVorschlaege: [],
      ladeVorschlaegeAktiv: false,

      protokoll: [],
      ladeProtokollAktiv: false,

      einstellungen: {
        "datenschutz.loeschUmfang": "MIT_ASSOZIIERTEN_DATEN",
        "datenschutz.modus": "MANUELL",
        "datenschutz.institutionKey": "",
      },
      schluesselSichtbar: false,
      schluesselGesperrt: false,
      schluesselKonfiguriert: false,
      schluesselNeuGeneriert: false,

      scanAktiv: false,
      bereinigungAktiv: false,

      lookup: { key: "", ahvNummer: "" },
      lookupErgebnis: null,
      lookupAktiv: false,
      lookupFehler: null,

      zurueckstellenOffen: false,
      zurueckstelltBis: null,
      zurueckstellenTarget: null,

      toSwissDatum,
      toSwissDatumZeit,

      vorschlaegeFelder: [
        { key: "selected", label: "", thStyle: { width: "40px" } },
        { key: "personName", label: "Person", sortable: true },
        { key: "fruehestensLoeschenAm", label: "Frist", sortable: true, formatter: toSwissDatum },
        { key: "erstelltAm", label: "Vorschlag erstellt", sortable: true, formatter: toSwissDatum },
        { key: "status", label: "Status" },
        { key: "actions", label: "" },
      ],
      protokollFelder: [
        { key: "ausgefuehrtAm", label: "Zeitpunkt", sortable: true, formatter: toSwissDatumZeit },
        { key: "personName", label: "Person" },
        { key: "aktion", label: "Aktion" },
        { key: "ausgefuehrtVon", label: "Von" },
        { key: "grund", label: "Grund" },
      ],
    };
  },
  computed: {
    morgen() {
      const d = new Date();
      d.setDate(d.getDate() + 1);
      return d.toISOString().substring(0, 10);
    },
  },
  mounted() {
    this.ladeVorschlaege();
  },
  methods: {
    async ladeVorschlaege() {
      this.ladeVorschlaegeAktiv = true;
      try {
        const resp = await AppApi.get(`${DATENSCHUTZ_VORSCHLAEGE_PATH}/`);
        this.vorschlaege = resp.data;
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      } finally {
        this.ladeVorschlaegeAktiv = false;
      }
    },
    async ladeProtokoll() {
      this.ladeProtokollAktiv = true;
      try {
        const resp = await AppApi.get(`${DATENSCHUTZ_PROTOKOLL_PATH}/`);
        this.protokoll = resp.data;
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      } finally {
        this.ladeProtokollAktiv = false;
      }
    },
    async ladeEinstellungen() {
      try {
        const resp = await AppApi.get(`${DATENSCHUTZ_EINSTELLUNGEN_PATH}/`);
        const { schluesselGesperrt, schluesselKonfiguriert, ...config } = resp.data;
        this.einstellungen = { ...config, "datenschutz.institutionKey": "" };
        this.schluesselGesperrt = !!schluesselGesperrt;
        this.schluesselKonfiguriert = !!schluesselKonfiguriert;
        this.schluesselNeuGeneriert = false;
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      }
    },
    async einstellungenSpeichern() {
      // Institutions-Schlüssel nur senden wenn in dieser Session neu generiert,
      // damit ein versehentliches Speichern den bestehenden Schlüssel nicht überschreibt.
      const payload = { ...this.einstellungen };
      if (!this.schluesselNeuGeneriert) delete payload["datenschutz.institutionKey"];
      try {
        await AppApi.post(`${DATENSCHUTZ_EINSTELLUNGEN_PATH}/`, payload);
        if (this.schluesselNeuGeneriert) {
          this.schluesselKonfiguriert = true;
          this.schluesselNeuGeneriert = false;
          this.schluesselSichtbar = false;
          this.einstellungen["datenschutz.institutionKey"] = "";
        }
        this.$notify({ type: "success", title: "Gespeichert", text: "Einstellungen wurden gespeichert." });
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      }
    },
    onVorschlagSelected(rows) {
      this.ausgewaehlteVorschlaege = rows;
    },
    alleAuswaehlen(selected) {
      if (selected) this.$refs.vorschlaegeTable.selectAllRows();
      else this.$refs.vorschlaegeTable.clearSelected();
    },
    async aktion(aktionTyp) {
      const ids = this.ausgewaehlteVorschlaege.map((v) => v.id);
      for (const vorschlagId of ids) {
        await this.sendeAktion(vorschlagId, aktionTyp, null);
      }
      await this.ladeVorschlaege();
    },
    async aktionEinzeln(item, aktionTyp) {
      if (aktionTyp === "ZURUECKSTELLEN") {
        const offen = this.zurueckstellenTarget === item.id;
        this.zurueckstellenTarget = offen ? null : item.id;
        this.zurueckstelltBis = null;
        return;
      }
      await this.sendeAktion(item.id, aktionTyp, null);
      await this.ladeVorschlaege();
    },
    schliesseZurueckstellenInline(item) {
      this.zurueckstellenTarget = null;
    },
    async sendeAktion(vorschlagId, aktionTyp, zurueckgestelltBis) {
      try {
        await AppApi.post(`${DATENSCHUTZ_VORSCHLAEGE_PATH}/`, { vorschlagId, aktion: aktionTyp, zurueckgestelltBis });
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      }
    },
    oeffneZurueckstellenDialog() {
      this.zurueckstelltBis = null;
      this.zurueckstellenOffen = true;
    },
    schliesseZurueckstellenDialog() {
      this.zurueckstellenOffen = false;
      this.zurueckstellenTarget = null;
    },
    async zurueckstellenBestaetigen() {
      const targets = this.zurueckstellenTarget
        ? [this.zurueckstellenTarget]
        : this.ausgewaehlteVorschlaege.map((v) => v.id);
      for (const id of targets) {
        await this.sendeAktion(id, "ZURUECKSTELLEN", this.zurueckstelltBis);
      }
      this.zurueckstellenTarget = null;
      await this.ladeVorschlaege();
    },
    generiereSchluessel() {
      const arr = new Uint8Array(32);
      window.crypto.getRandomValues(arr);
      this.einstellungen["datenschutz.institutionKey"] = Array.from(arr).map(b => b.toString(16).padStart(2, "0")).join("");
      this.schluesselSichtbar = true;
      this.schluesselNeuGeneriert = true;
    },
    async triggereJob(jobTyp) {
      if (jobTyp === "SCAN") this.scanAktiv = true;
      else this.bereinigungAktiv = true;
      try {
        const resp = await AppApi.post(`${DATENSCHUTZ_JOBS_PATH}/`, { job: jobTyp });
        const d = resp.data;
        let text = "";
        if (jobTyp === "SCAN") {
          text = d.vorschlaegeNeu > 0
            ? `${d.vorschlaegeNeu} neue Vorschläge erstellt (${d.vorschlaegeGesamt} offen gesamt)`
            : `Keine neuen Vorschläge — ${d.vorschlaegeGesamt} offen gesamt`;
        } else {
          text = d.uuidsGefuellt > 0
            ? `${d.uuidsGefuellt} datenschutz_uuid befüllt — ${d.uuidsNochFehlend} noch fehlend`
            : d.uuidsNochFehlend > 0
              ? `Keine UUID befüllt — ${d.uuidsNochFehlend} fehlend (Institutions-Schlüssel konfiguriert?)`
              : "Alle datenschutz_uuid bereits gesetzt";
        }
        this.$notify({ type: "success", title: "Job abgeschlossen", text });
        if (jobTyp === "SCAN") await this.ladeVorschlaege();
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      } finally {
        this.scanAktiv = false;
        this.bereinigungAktiv = false;
      }
    },
    async oeffneDokument(item) {
      try {
        const resp = await AppApi.get(`${DATENSCHUTZ_LOOKUP_PATH}/`, {
          params: { id: item.id },
          responseType: "blob",
        });
        FileDownload(resp.data, item.bezeichnung || "dokument");
      } catch (e) {
        this.$notify(apiErrorToAlert(e));
      }
    },
    async ausfuehrenLookup() {
      this.lookupAktiv = true;
      this.lookupFehler = null;
      this.lookupErgebnis = null;
      try {
        const resp = await AppApi.post(`${DATENSCHUTZ_LOOKUP_PATH}/`, {
          key: this.lookup.key,
          ahvNummer: this.lookup.ahvNummer,
        });
        this.lookupErgebnis = resp.data;
      } catch (e) {
        this.lookupFehler = e?.response?.data?.error || "Ungültiger Schlüssel oder Fehler bei der Abfrage.";
      } finally {
        this.lookupAktiv = false;
      }
    },
    istAnonymisiert(item) {
      return item.personName && item.personName.includes("[Anonymisiert]");
    },
    aktionLabel(aktion) {
      const labels = {
        PHASE1_ANONYMISIERT: "Phase 1: Anonymisiert",
        PHASE2_GELOESCHT: "Phase 2: Gelöscht",
        LOESCHUNG_AUF_ANFRAGE: "Löschung auf Anfrage",
        VORSCHLAG_BESTAETIGT: "Vorschlag bestätigt",
        VORSCHLAG_ABGELEHNT: "Vorschlag abgelehnt",
        ZURUECKGESTELLT: "Zurückgestellt",
      };
      return labels[aktion] || aktion;
    },
    aktionBadgeClass(aktion) {
      if (aktion === "PHASE2_GELOESCHT" || aktion === "LOESCHUNG_AUF_ANFRAGE") return "badge badge-danger";
      if (aktion === "PHASE1_ANONYMISIERT") return "badge badge-warning";
      if (aktion === "VORSCHLAG_BESTAETIGT") return "badge badge-success";
      if (aktion === "ZURUECKGESTELLT") return "badge badge-secondary";
      return "badge badge-light";
    },
  },
};
</script>
